import { parse } from 'qs';

import { localStorage } from '@sorare/core/src/lib/storage/localStorage';
import { sessionStorage } from '@sorare/core/src/lib/storage/sessionStorage';

import {
  queryParamsToLocalStorageKeys,
  queryParamsToSessionStorageKeys,
} from './storage.ts';

// eslint-disable-next-line no-restricted-properties
const searchParams = parse(window.location.search, {
  ignoreQueryPrefix: true,
  decoder(value) {
    if (/^(\d+|\d*\.\d+)$/.test(value)) {
      return parseFloat(value);
    }
    const keywords: Record<string, boolean | null | undefined> = {
      true: true,
      false: false,
      null: null,
      undefined,
    };
    if (value in keywords) {
      return keywords[value];
    }
    return value;
  },
});

const LOCAL_STORAGE_ENTRIES = Object.entries(queryParamsToLocalStorageKeys);
// if any UTM params are present, clear former ones from local storage first to avoid merging them together
if (LOCAL_STORAGE_ENTRIES.some(([qs]) => searchParams[qs])) {
  LOCAL_STORAGE_ENTRIES.forEach(([, lsKey]) => localStorage.removeItem(lsKey));
}
LOCAL_STORAGE_ENTRIES.forEach(([qsKey, lskey]) => {
  const value = searchParams[qsKey];
  if (value) {
    localStorage.setItem(
      lskey,
      typeof value === 'string' ? value : JSON.stringify(value)
    );
  }
});
Object.entries(queryParamsToSessionStorageKeys).forEach(([qsKey, sskey]) => {
  const value = searchParams[qsKey];
  if (value !== undefined) {
    sessionStorage.setItem(
      sskey,
      typeof value === 'string' ? value : JSON.stringify(value)
    );
  }
});
